import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=17be5d76&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=17be5d76&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be5d76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17be5d76')) {
      api.createRecord('17be5d76', component.options)
    } else {
      api.reload('17be5d76', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=17be5d76&scoped=true&", function () {
      api.rerender('17be5d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/loading/loading.vue"
export default component.exports